// Channel-agnostic display helpers.

export function formatMicros(micros: number, currency = "AUD"): string {
  return formatCurrency(micros / 1_000_000, currency);
}

export function formatCurrency(amount: number, currency = "AUD"): string {
  return new Intl.NumberFormat("en-AU", {
    style: "currency",
    currency,
    maximumFractionDigits: 0,
  }).format(amount);
}

export function formatInt(n: number): string {
  return new Intl.NumberFormat("en-AU").format(Math.round(n));
}

export function formatPercent(ratio: number, fractionDigits = 2): string {
  return `${(ratio * 100).toFixed(fractionDigits)}%`;
}

export function formatDecimal(n: number, fractionDigits = 2): string {
  return n.toFixed(fractionDigits);
}

export function timeAgo(iso: string): string {
  const ms = Date.now() - new Date(iso).getTime();
  const s = Math.floor(ms / 1000);
  if (s < 60) return `${s}s ago`;
  const m = Math.floor(s / 60);
  if (m < 60) return `${m}m ago`;
  const h = Math.floor(m / 60);
  if (h < 24) return `${h}h ago`;
  const d = Math.floor(h / 24);
  return `${d}d ago`;
}
